import type { ConceptDef } from '../types';

export const intraverbalSynonyms: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-synonyms',
  label: 'Intraverbal Same Meaning',
  category: 'Intraverbal',
  description: 'Hear a word; tap a word that means the same.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Means the same as big.', answer: '🐘 large' },
      { say: 'Means the same as small.', answer: '🤏 little' },
      { say: 'Means the same as happy.', answer: '😀 glad' },
      { say: 'Means the same as scared.', answer: '😨 afraid' },
      { say: 'Means the same as fast.', answer: '⚡ quick' },
      { say: 'Means the same as quiet.', answer: '🤫 silent' },
    ],
  },
};
